module.exports = __webpack_public_path__ + "static/media/seaworthy.7fc2f5e0.png";